import { Accordion, withStyles } from '@material-ui/core';

// 履歴表示で利用するAccordion
// アコーディオンを開いたときのmarginの制御をuseStylesではできなかったのでwityStylesを使用
export const HistoryDiffAccordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(Accordion);
